import axios from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { findAndCreateCheckup } from '../lib/api';
import { CheckupTag, CreateCheckupResponse } from '@companion-professional/dctypes';

export type QuickCheckupFormValues = {
  clinicId: string;
  clinicPetId: string;
  locationTag: CheckupTag;
};

export type QuickCheckupCreateResult =
  | { type: 'success'; response: CreateCheckupResponse }
  | { type: 'pet_not_found' };

export const useQuickCheckupCreate = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync: createQuickCheckup,
    isPending,
    error
  } = useMutation({
    mutationFn: async (values: QuickCheckupFormValues): Promise<QuickCheckupCreateResult> => {
      try {
        // TODO: Currently hard-coding a single request because we currently only support one request.  Need to update
        //  this to support multiple requests and other types.
        const res = await findAndCreateCheckup(values.clinicId, values.clinicPetId, [{ video_type: 'default' }], [
          values.locationTag
        ]);
        await queryClient.invalidateQueries({
          queryKey: ['active-checkups']
        });
        await queryClient.invalidateQueries({
          queryKey: ['pet-checkups', res.pet_id]
        });
        return { type: 'success', response: res };
      } catch (e) {
        if (axios.isAxiosError(e) && e.response?.status === 404) {
          return { type: 'pet_not_found' };
        }
        throw e;
      }
    }
  });

  return {
    createQuickCheckup,
    isPending,
    error
  };
};
